export default {
	props: {
		formCreateInject: {
			default: () => {
				return null
			}
		},
		listforeingKey: {
			default: () => {
				return {}
			}
		},		
		selectoptions: {
			default: () => {
				return []
			}
		},
		emptyoption:{
			type: Boolean,
			default: () => {
				return true
			}
		},
		enableSelectOption: {
			type: Array,
			default: () => {
				return []
			}
		},
		isfilter: {
			default: () => {
				return false
			}
		},
		table: {
			type: Object,
			default: () => {
				return null
			}
		},
		tableFormInfo: {
			type: Object,
			default: () => {
				return null
			}
		},
		showPassword: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		collapseTags: {
			default: () => {
				return true
			}
		},
		el: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		name: {
			type: String,
			default: () => {
				return ''
			}
		},
		size: {
			type: String,
			default: () => {
				return 'small'
			}
		},
		placeholder: {
			type: String,
			default: () => {
				return ''
			}
		},
		value: {
			default: () => {
				return ''
			}
		},
		disabled: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		readonly: {
			default: () => {
				return false
			}
		},
		multiple: {
			default: () => {
				return false
			}
		},


		renderCell: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		renderEdit: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		clearable: {
			type: Boolean,
			default: () => {
				return true
			}
		},
		allowCreate: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		filterable: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		min: {
			type: Number,
			default: () => {
				return -Infinity
			}
		},
		max: {
			type: Number,
			default: () => {
				return Infinity
			}
		},
		precision: {
			type: Number,
			default: () => {
				return 1
			}
		},
		step: {
			type: Number,
			default: () => {
				return 1
			}
		},
		inactiveValue: {
			type: Number,
			default: () => {
				return 0
			}
		},
		activeValue: {
			type: Number,
			default: () => {
				return 1
			}
		},
		controlsPosition: {
			type: String,
			default: () => {
				return 'right'
			}
		},
		islist: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		row: {
			default: () => {
				return null
			}
		},
		column: {
			type: Object,
			default: () => {
				return null
			}
		}
	},
	data() {
		return {
			ready: false,
			sourceData: [],
			options: [],
			relationValue: [],
		}
	},
	created() {
		this.list()
	},
	watch: {
		name(newval, oldval) {
			if (oldval == '') {
				this.list()
			}
		}
	},
	computed: {
		emunSource() {
			return window.systemData.emun
		}
	},

	methods: {
		getEmun() {
			//console.log(window.systemData.options,this.name)
			if (window.systemData.options && window.systemData.options[this.name]) {
				this.sourceData = window.systemData.options[this.name].sourceData
				window.systemData.options[this.name].options.forEach((item) => {					
					if(this.filterOption(item)){					
						this.options.push(item)
					}
					// item.enable = this.filterOption(item) ? 5 : 6
					// this.options.push(item)
				})
			} else {
				let data = []
				this.emunSource.forEach((item) => {
					if (item.field === this.name) {
						data.push(JSON.parse(JSON.stringify(item)))
					}
				})
				this.sourceData = data
				this.options = this.createTree(data)

			}
		},
		createTree(data) {		
			let root = []
			data.forEach((item) => {
				item.enable = this.filterOption(item) ? 5 : 6
				if (!item.parentid) {
					root.push(item)
				}
				data.forEach((_item) => {
					if (_item.parentid === item.id) {
						if (!item.children) {
							item.children = []
						}
						item.children.push(_item)
					}

				})
			})
			return root
		},
		filterOption(item,field='auth') {
			let hasAuth = window.systemMethods.hasAuth(item,field)
			let isEableSelectOption = true
			if (this.enableSelectOption.length != 0) {
				isEableSelectOption = this.enableSelectOption.includes(item.id)
			}
			return hasAuth && isEableSelectOption

		},
		list() {
			//console.log(this.selectoptions,123123)
			if (this.name != '') {
				this.getEmun()

				if (this.options.length == 0) {
					this.$api.emun.list({
						field: this.name
					}).then((res) => {
						this.options = this.createTree(res)
						this.finish()
					})
				} else {
					this.finish()
				}
			} else {
				this.options = this.selectoptions
			}
			if( !this.formCreateInject && !this.row && this.emptyoption){
				let existEmpty = this.options.find((item)=>{
					return item.value == '为空'
				})
				if(!existEmpty){
					this.options.unshift({
						id:0,
						label: '为空',
						value: '为空'
					})
				}

			}

		},
		change(val) {

			if (val) {
				//console.log(Object.hasOwn(val, 'value') ? val.value : val)
				this.$emit('change', Object.hasOwn(val, 'value') ? val.value : val)
				this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
			} else {
				this.$emit('change', null)
				this.$emit('input', null)
			}
			if (this.el) {
				this.formCreateInject.api.validateField(this.formCreateInject.field)
			}
		},
		blur(e) {
			this.$emit('blur', e)
		},
		labelTovalue(label,parent = null) {
			let value = null
			this.sourceData.forEach((item) => {
				if (item.label == label) {
					value = item.value
				}
			})
			if(!value && parent){
				this.sourceData.forEach((item) => {
					if (item.parentid == parent) {
						value = value?value:item.value
					}
				})
			}
			return value
		},
		getRelationValue(value, init = true) {
			if (init) {
				this.relationValue = []
			}
			let res = null
			this.sourceData.forEach((item) => {
				if (item.id == value) {
					res = item
				}
			})
			if (res) {
				this.relationValue.unshift(res.id)
				if (res.parentid) {
					return this.getRelationValue(res.parentid, false)
				}
			}
			if (this.relationValue.length == 0) {
				return null
			} else if (this.relationValue.length == 1) {
				return this.relationValue[0]
			} else {
				return this.relationValue
			}

		},
		getOption() {
			return this.options
		},
		getCodeByValue(value) {
			let code = null
			for (let i = 0; i < this.sourceData.length; i++) {
				if (this.sourceData[i].id == value) {
					return this.sourceData[i].code
				}
			}

			return code
		},
		finish() {
			this.ready = true
			this.$emit('ready')
		}
	}
}